/* eslint-disable */
/* eslint-disable prettier/prettier */
import React from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'

const COLORS = ['#6A7EEF', '#FFD700', '#2C3E50', '#FF8C00', '#95A5A6']

const RatingChart = ({ data }) => {
  // Process the API data to match the chart format
  const processChartData = (apiData) => {
    if (!apiData?.data?.overall?.chartData?.ratingChart) {
      // Fallback data if no API data available
      return [
        { name: '5 star', value: 87 },
        { name: '4 star', value: 38 },
        { name: '3 star', value: 29 },
        { name: '2 star', value: 21 },
        { name: '1 star', value: 0 },
      ]
    }

    const ratingData = apiData.data.overall.chartData.ratingChart
    
    // Create a complete rating structure (1-5 stars)
    const completeRatings = {
      1: { count: 0, percentage: 0 },
      2: { count: 0, percentage: 0 },
      3: { count: 0, percentage: 0 },
      4: { count: 0, percentage: 0 },
      5: { count: 0, percentage: 0 }
    }

    ratingData.forEach(item => {
      const starRating = Math.floor(item.star) 
      if (completeRatings[starRating]) {
        completeRatings[starRating].count += item.count
        completeRatings[starRating].percentage += item.percentage
      }
    })

    return Object.entries(completeRatings)
      .map(([star, data]) => ({
        name: `${star} star`,
        value: data.count,
        percentage: data.percentage
      }))
      .sort((a, b) => b.name.localeCompare(a.name)) 
  }

  const chartData = processChartData(data)
  const totalRatings = chartData.reduce((sum, item) => sum + item.value, 0)

  return (
    <div className="w-full h-full bg-white p-4 rounded-lg">
      <div className="mb-2">
        <h3 className="text-lg font-semibold text-gray-800">Rating</h3>
        <div className="text-sm text-gray-600 mt-1">
          <span>Total number of rating</span>
        </div>
        <div className="text-2xl font-bold text-gray-900 mt-1">
          {data?.data?.overall?.summary?.totalReviews || totalRatings}
        </div>
      </div>
      
      <div className="flex items-center justify-between">
        {/* Pie Chart */}
        <div className="flex-shrink-0">
          <ResponsiveContainer width={200} height={200}>
            <PieChart>
              <Pie 
                data={chartData} 
                cx="50%" 
                cy="50%" 
                innerRadius={50} 
                outerRadius={80} 
                fill="#8884d8" 
                dataKey="value"
                startAngle={90}
                endAngle={-270}
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                labelStyle={{ fontWeight: 'bold', color: '#333' }}
                itemStyle={{ color: '#555' }}
                formatter={(value, name, props) => [
                  `${value} reviews (${props.payload.percentage}%)`, 
                  `${name}`
                ]}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        {/* Custom Legend */}
        <div className="flex flex-col space-y-2 ml-6">
          {chartData.map((entry, index) => (
            <div key={entry.name} className="flex items-center space-x-2">
              <div 
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              />
              <span className="text-sm text-gray-700">
                {entry.name}
              </span>
              <span className="text-sm font-semibold text-gray-900 ml-auto">
                {entry.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RatingChart